/**
 * Sets both a function and object React ref.
 */
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

export { setRef };